import React, { Component } from "react";
import { Header, Icon, Grid, Divider } from "semantic-ui-react";
import "./home.css";
import MessageOfTheDayCard from "./messageoftheday";
import LaborAtAGlanceCard from "./laborglance";

import CompanyCalendarCard from "./companycalendar";
import AssignedJobsCard from "./assignedjobsmobile";
class HomeMobile extends Component {
  state = {
    activeindex: null
  };
  render() {
    return (
      <div className="Home" id="homemobile">
        <Grid divided="vertically">
          <Grid.Row columns={1}>
            <Grid.Column width={12}>
              <MessageOfTheDayCard mobile motd={this.props.motd} />

              <Divider />

              <Header as="h3">
                <Header as="h3">
                  <Icon name="balance" />
                  Labor Overview
                </Header>
              </Header>

              <LaborAtAGlanceCard
                mobile
                weekhours={this.props.weekhours}
                myinfo={this.props.myinfo}
              />
              <Divider />

              <Header as="h3">
                <Icon color="black" name="suitcase" /> Assigned Jobs
              </Header>

              <AssignedJobsCard
                mobile
                jobs={this.props.jobs}
                wods={this.props.wods}
                time={this.props.time}
              />
              <Divider />
              <Header as="h3">
                <Icon name="calendar" />
                Company Calendar
              </Header>

              <CompanyCalendarCard mobile />
              {/*}
              <LaborAtAGlanceCard mobile={true} />
              <Divider />
              <NoteToSelfCard mobile={true} />
              <Divider />
              <MessageSystemCard mobile={true} />
              <Divider />
              <AssignedJobsCard mobile={true} />
              <Divider />
              <CompanyCalendarCard mobile={true} />
              <Divider />
              <ExpectedAbsences mobile={true} />
              */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default HomeMobile;



// WEBPACK FOOTER //
// ./src/components/home-components/homemobile.js